import React, { useState, useEffect } from "react";
import { Axios } from "../config";
import Navbar from "../Components/Navbar";
import "../Style/Admin.css";
import { useAuth } from "./Auth";
import { useParams } from "react-router-dom";

function Admin() {
  var { username } = useParams();
  const auth = useAuth();
  const [file, setFile] = useState(null);
  const [selectedFormat, setSelectedFormat] = useState("35 Overs");
  const [selectedTeam, setSelectedTeam] = useState("Shaheen Warriors");
  const [gameData, setGameData] = useState([]); // Corrected to use useState
  const [message, setMessage] = useState([]);
  const [fileName, setFileName] = useState("");
  const [FinalMessage, setFinalMessage] = useState("");
  const [showMessages, setShowMessages] = useState(false); // State variable to toggle message visibility
  const [newUser, setNewUsername] = useState("");
  const [newPassword, setNewPassowrd] = useState("");
  const [newPassword2, setNewPassowrd2] = useState("");
  const [passwordDifferentError, setPasswordDifferentError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [editingEvent, setEditingEvent] = useState(null);
  // New event form state variables
  const [eventName, setEventName] = useState("");
  const [description, setDescription] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [location, setLocation] = useState("");
  const [ticketsLink, setTicketsLink] = useState("");

  const handleFileChange = (event) => {
    // Extract the filename from the file object
    const fileName = event.target.files[0].name;
    // Set the filename in state
    setFileName(fileName);
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    fetchEvents();
    fetchData();
  }, [message]);

  const fetchEvents = () => {
    Axios.get("/upcomingEvents")
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error("Error fetching events:", error);
      });
  };

  const fetchData = () => {
    Axios.post("/GetGamesData")
      .then((response) => {
        console.log("Data fetched successfully:", response.data);

        // Process the data to extract the dates and sort
        const processedData = response.data.map((game) => {
          // Extract the date from the gameDetails string
          const dateMatch = game.GameDetails.match(/\((\d{2}\/\d{2}\/\d{4})\)/);
          const dateStr = dateMatch ? dateMatch[1] : null;

          // Convert the extracted date string to a Date object
          const dateObj = dateStr ? new Date(dateStr) : null;

          return {
            ...game,
            dateObj, // Add the Date object to the game data
          };
        });

        // Sort the processed data based on the Date objects
        processedData.sort((a, b) => {
          if (a.dateObj && b.dateObj) {
            return b.dateObj - a.dateObj; // Sort in descending order
          } else if (a.dateObj) {
            return -1;
          } else if (b.dateObj) {
            return 1;
          } else {
            return 0;
          }
        });

        setGameData(processedData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handleEditEvent = (event) => {
    setEditingEvent(event);
    setEventName(event.EventName);
    setDescription(event.Description);
    setEventDate(event.Date.split(".")[0]); // Remove milliseconds if present
    setLocation(event.Location);
    setTicketsLink(event.TicketsLink || "");
  };

  const handleDeleteEvent = (eventId) => {
    if (window.confirm("Are you sure you want to delete this event?")) {
      Axios.delete(`/upcomingEvents/${eventId}`)
        .then((response) => {
          if (response.data.success) {
            fetchEvents(); // Refresh the list
          }
        })
        .catch((error) => {
          console.error("Error deleting event:", error);
        });
    }
  };

  const handleUpdateEvent = () => {
    Axios.put(`/upcomingEvents/${editingEvent.EventID}`, {
      eventName,
      description,
      eventDate,
      location,
      ticketsLink,
    })
      .then((response) => {
        if (response.data.success) {
          fetchEvents();
          setEditingEvent(null);
          // Clear the form
          setEventName("");
          setDescription("");
          setEventDate("");
          setLocation("");
          setTicketsLink("");
        }
      })
      .catch((error) => {
        console.error("Error updating event:", error);
      });
  };

  const HandleAddUser = async (e) => {
    e.preventDefault(); // Prevent form submission from reloading the page

    if (newPassword === newPassword2) {
      setPasswordDifferentError("");
      try {
        const response = await Axios.post("/AddUser", {
          username: newUser,
          password: newPassword,
        });
        if (response.data.success) {
          setPasswordDifferentError(response.data.message);
          setIsSuccess(true);
          setNewUsername("");
          setNewPassowrd("");
          setNewPassowrd2("");
        } else {
          setPasswordDifferentError(response.data.message);
          setIsSuccess(false);
        }
      } catch (error) {
        console.error("Error adding user:", error);
        setPasswordDifferentError("Error adding user. Please try again.");
        setIsSuccess(false);
      }
    } else {
      setPasswordDifferentError("Passwords do not match.");
      setIsSuccess(false);
    }
  };

  const handleFileUpload = () => {
    if (!file) {
      console.error("No file selected.");
      return;
    }
    setLoading(false);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("format", selectedFormat);
    formData.append("team", selectedTeam);

    if (selectedFormat !== null && selectedTeam !== null) {
      Axios.post("/uploadData", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          console.log(response.data);
          setMessage(response.data);
          let isErrorFound = false; // Flag to track if an error is found

          for (const element of response.data) {
            if (element.includes("Error:")) {
              setFinalMessage("Error found!");
              isErrorFound = true; // Set the flag to true if an error is found
              console.log("error found");
              break; // Exit the loop if an error is found
            }
          }

          if (!isErrorFound) {
            setFinalMessage("The game was added successfully!");
          }
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    } else {
      console.log("smthn is null");
    }

    setLoading(true);
  };

  const handleAddEvent = () => {
    console.log(`methodd`);
    Axios.post("/AddEvent", {
      eventName,
      description,
      eventDate,
      location,
      ticketsLink,
    })
      .then((response) => {
        console.log("Event added successfully:", response.data);
        fetchEvents(); // Add this line
        // Optionally clear the form or show success message here
        setEventName("");
        setDescription("");
        setEventDate("");
        setLocation("");
        setTicketsLink("");
      })
      .catch((error) => {
        console.error("Error adding event:", error);
        // Optionally show error message here
      });

    console.log("Adding event:", {
      eventName,
      description,
      eventDate,
      location,
      ticketsLink,
    });

    // Clear the form
    setEventName("");
    setDescription("");
    setEventDate("");
    setLocation("");
    setTicketsLink("");
  };

  const handleFormatChange = (event) => {
    setSelectedFormat(event.target.value);
  };

  const handleTeamChange = (event) => {
    setSelectedTeam(event.target.value);
  };

  return (
    <div className="App">
      <React.Fragment>
        <Navbar />
      </React.Fragment>
      <div className="top20">
        <div className="teamName">
          <b>Admin Portal</b>
        </div>
        <div className="input-user">
          {/* New File */}
          <div className="inputs-div">
            <div className="modalNames">
              <b>Add a game</b>
            </div>
            <input type="file" onChange={handleFileChange} />
            <label htmlFor="section">Select Section:</label>
            <select
              id="section"
              value={selectedFormat}
              onChange={handleFormatChange}
            >
              <option value="35 Overs">35 Overs</option>
              <option value="T20">T20</option>
              <option value="Weeknight">Weeknight</option>
            </select>
            <select
              id="section2"
              value={selectedTeam}
              onChange={handleTeamChange}
            >
              <option value="Shaheen Mavericks">Shaheen Mavericks</option>
              <option value="Shaheen Gladiators">Shaheen Gladiators</option>
              <option value="Shaheen Warriors">Shaheen Warriors</option>
              <option value="Shaheen Knights">Shaheen Knights</option>
              <option value="Shaheen Titans">Shaheen Titans</option>
            </select>
            <button className="blue-button" onClick={handleFileUpload}>
              Upload CSV File
            </button>
            {/* Button to toggle message visibility */}
            <button
              className="filterButton"
              onClick={() => setShowMessages(!showMessages)}
            >
              {showMessages ? "Hide Details" : "Show Details"}
            </button>
            <b
              className="filterButton"
              style={{
                color: FinalMessage.toLowerCase().includes("success")
                  ? "green"
                  : FinalMessage.toLowerCase().includes("error")
                    ? "red"
                    : "black",
              }}
            >
              {FinalMessage} - {fileName}
            </b>
            {/* Messages container */}
            {showMessages && (
              <div>
                {message.map((mes, index) => (
                  <div
                    className={`Admin-Message ${
                      mes.toLowerCase().includes("error") ? "error" : ""
                    } ${
                      mes.toLowerCase().includes("success") ? "success" : ""
                    }`}
                    key={index}
                  >
                    {mes}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Upcoming Event Form */}
          <div className="inputs-div">
            <div className="modalNames">
              <b>{editingEvent ? "Edit Event" : "Add an Upcoming Event"}</b>
            </div>

            <label htmlFor="eventName">Event Name:</label>
            <input
              type="text"
              id="eventName"
              name="eventName"
              placeholder="Enter event name"
              value={eventName}
              onChange={(e) => setEventName(e.target.value)}
              required
            />

            <label htmlFor="description">Description:</label>
            <textarea
              id="description"
              name="description"
              placeholder="Enter event description"
              rows="3"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            ></textarea>

            <label htmlFor="eventDate">Date and Time:</label>
            <input
              type="datetime-local"
              id="eventDate"
              name="eventDate"
              value={eventDate}
              onChange={(e) => setEventDate(e.target.value)}
              required
            />

            <label htmlFor="location">Location:</label>
            <input
              type="text"
              id="location"
              name="location"
              placeholder="Enter location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              required
            />

            <label htmlFor="ticketsLink">Tickets Link (optional):</label>
            <input
              type="url"
              id="ticketsLink"
              name="ticketsLink"
              placeholder="https://"
              value={ticketsLink}
              onChange={(e) => setTicketsLink(e.target.value)}
            />

            {editingEvent ? (
              <>
                <button
                  type="button"
                  onClick={handleUpdateEvent}
                  className="blue-button"
                >
                  Update Event
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setEditingEvent(null);
                    // Clear the form
                    setEventName("");
                    setDescription("");
                    setEventDate("");
                    setLocation("");
                    setTicketsLink("");
                  }}
                  className="gray-button"
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                type="button"
                onClick={handleAddEvent}
                className="blue-button"
              >
                Add Event
              </button>
            )}
          </div>

          {/* New User */}
          <div className="NewUser">
            <div className="modalNames">
              <b>Add an admin</b>
            </div>
            <form action="" onSubmit={HandleAddUser}>
              <div>
                <div className="NewUserNameInput">
                  <label htmlFor="text">User name</label>
                  <input
                    type="text"
                    placeholder="Enter new username"
                    onChange={(e) => setNewUsername(e.target.value)}
                    className="NewUserInputs"
                    value={newUser}
                  ></input>
                </div>
                <div className="NewUserNameInput">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    placeholder="Enter password"
                    onChange={(e) => setNewPassowrd(e.target.value)}
                    className="NewUserInputs"
                    value={newPassword}
                  ></input>
                  <br />
                  <input
                    type="password"
                    placeholder="Enter the same password"
                    onChange={(e) => setNewPassowrd2(e.target.value)}
                    className="NewUserInputs"
                    value={newPassword2}
                  ></input>
                </div>
                <b style={{ color: isSuccess ? "green" : "red" }}>
                  {passwordDifferentError}
                </b>
                <br />
                <button type="submit">Add the user</button>
              </div>
            </form>
          </div>
        </div>

        {/* Game table */}
        <div className="table-div-admin border-admin-table">
          <h3>Games Added</h3>
          <table className="game-data-table">
            <thead>
              <tr>
                <th
                  style={{
                    padding: "8px",
                    borderBottom: "1px solid #ddd",
                    background: "#f2f2f2",
                    color: "#333",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Game Details
                </th>
                <th
                  style={{
                    padding: "8px",
                    borderBottom: "1px solid #ddd",
                    background: "#f2f2f2",
                    color: "#333",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Season Year
                </th>
              </tr>
            </thead>
            <tbody>
              {gameData && gameData.length > 0 ? (
                gameData.map((game) => (
                  <tr key={game.GameID}>
                    <td>{game.GameDetails}</td>
                    <td>{game.SeasonYear}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No game data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="table-div-admin border-admin-table">
          <h3>Upcoming Events</h3>
          <table className="game-data-table">
            <thead>
              <tr>
                <th>Event Name</th>
                <th>Description</th>
                <th>Date</th>
                <th>Location</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.EventID}>
                  <td>{event.EventName}</td>
                  <td>{event.Description}</td>
                  <td>{new Date(event.Date).toLocaleString()}</td>
                  <td>{event.Location}</td>
                  <td>
                    <button
                      onClick={() => handleEditEvent(event)}
                      className="edit-button"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteEvent(event.EventID)}
                      className="delete-button"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Admin;
